import React from 'react';
import Container from 'react-bootstrap/Container';
import Stack from 'react-bootstrap/Stack';
import LogoLoader from '../shared/results/logo-loader';
import { useAuth } from '../../../providers/auth-provider';

function LeaderConfidentialPage({ candidate }) {
  const { slug } = useAuth();

  return (
    <Container className="bg-white mt-2 mb-3 candidate-profile-assessments">
      {candidate && (
        <Stack gap={0} className="m-auto w-75" style={{ paddingTop: '8em', paddingBottom: '4em' }}>
          <div className="text-center w-100" style={{ paddingBottom: '4em' }}>
            <LogoLoader slug={slug} fileName={'login-logo.png'} style={{ height: '8em' }} className="" />
          </div>
          <div className="text-center pb-4" style={{ fontSize: '2em', fontWeight: 'bold', fontStyle: 'italic' }}>
            Confidential Document
          </div>
          <div className="text-center" style={{ fontSize: '1.5em' }}>
            Assessment Report for:
          </div>
          <div className="text-center" style={{ fontSize: '1.5em' }}>
            {candidate.name}
          </div>
          <div className="text-center pb-4 pt-4" style={{ fontSize: '1.25em' }}>
            Date of Assessment: {candidate.submitted}
          </div>
          <div className="pb-3">
            This report is a summary of the findings of an assessment conducted by Hutrics. It is designed to highlight
            the strengths and development needs of {candidate.name}. Because this information is of a personal nature,
            it is important that the following be considered:
          </div>
          <div>
            <ul>
              <li style={{ fontWeight: 'normal !important' }}>
                This information is confidential and should be stored in a secure file.
              </li>
              <li>
                This information is dated. Because people grow and develop over time, these results should be considered
                valid for no more than one year.
              </li>
              <li>This report should not be reproduced</li>
            </ul>
          </div>
          <div className="pb-2">
            To ensure that this information is used in the most helpful and ethical manner, this page should remain
            attached to this document at all times.
          </div>
        </Stack>
      )}
    </Container>
  );
}

export default LeaderConfidentialPage;
